import Tags from 'components/Tags';
import { Workplace } from 'data/firestore/agent/workplace/types';
import { useParams } from 'react-router-dom';
import {
    AvatarContainer,
    NameLabel,
    StyledBuilding,
} from './styled';

interface WorkplaceInfoProps {
    workplace?: Workplace | null;
}

const WorkplaceInfo = ({
    workplace,
}: WorkplaceInfoProps) => {
    const { agentId } = useParams();
    return (
        <AvatarContainer>
            <StyledBuilding />
            <NameLabel>
                {workplace?.name}
            </NameLabel>
            <Tags
                value={workplace?.tags}
                maxBadges={2}
                agentId={agentId as string}
                entity="workspace"
            />
        </AvatarContainer>
    );
};

export default WorkplaceInfo;
